import { Checkbox, Tag, Typography } from 'antd';
import React from 'react';
import LibraryThumbnail from './LibraryThumbnail';

// Mode « Grandes icônes » : mêmes interactions que la vue Détails (clic,
// Ctrl+clic, double-clic, Entrée, clic droit). Seuls les fichiers ont une case.
const MediaIconsGrid = ({
  dataSource,
  selectedRowKeys,
  onSelectionChange,
  focusedKey,
  onRowClick,
  onRowOpen,
  onRowContextMenu,
}) => {
  const toggle = (key) =>
    onSelectionChange(
      selectedRowKeys.includes(key)
        ? selectedRowKeys.filter((selected) => selected !== key)
        : [...selectedRowKeys, key]
    );

  return (
    <div
      role="listbox"
      aria-label="Contenu du dossier"
      aria-multiselectable="true"
      style={{
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
        gap: 12,
        alignContent: 'start',
        padding: 4,
      }}
    >
      {dataSource.map((record) => {
        const isSelected =
          selectedRowKeys.includes(record.key) || record.key === focusedKey;
        return (
          <div
            key={record.key}
            role="option"
            aria-selected={isSelected}
            aria-label={record.name}
            tabIndex={0}
            onClick={(event) => onRowClick(record, event)}
            onDoubleClick={() => onRowOpen(record)}
            onKeyDown={(event) => {
              if (event.key === 'Enter') onRowOpen(record);
            }}
            onContextMenu={(event) => onRowContextMenu(record, event)}
            title={record.name}
            style={{
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 6,
              padding: 8,
              borderRadius: 8,
              border: `1px solid ${isSelected ? '#91caff' : 'transparent'}`,
              background: isSelected ? '#e6f4ff' : 'transparent',
              cursor: 'default',
              userSelect: 'none',
            }}
          >
            {!record.isFolder && (
              <Checkbox
                checked={selectedRowKeys.includes(record.key)}
                aria-label={`Sélectionner ${record.name}`}
                onClick={(event) => event.stopPropagation()}
                onChange={() => toggle(record.key)}
                style={{ position: 'absolute', top: 8, left: 8, zIndex: 1 }}
              />
            )}
            <LibraryThumbnail record={record} />
            <Typography.Text
              ellipsis
              style={{ width: '100%', textAlign: 'center', fontSize: 13 }}
            >
              {record.name}
            </Typography.Text>
            {record.already_sent_for_qualification && (
              <Tag color="blue" style={{ marginInlineEnd: 0 }}>
                Déjà envoyé
              </Tag>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MediaIconsGrid;
